import React, { Component } from "react";

import ReactUUID from "react-uuid";

export default class UBXNotice extends Component {
    constructor(props) {
        super(props);

        this.state = {
            id: "",
            show: false,
            autoDismiss: false,
            dismissTO: null,
        };

        this.dismiss = this.dismiss.bind(this);
    }

    async componentDidMount() {
        const { id = ReactUUID(), show = false, autoDismiss = false } = this.props;

        await this.setState({ id, autoDismiss, show });
    }

    onClick(e) {
        const { onClick = false } = this.props;

        if (onClick) {
            onClick(e);
        }
    }

    onShow() {
        const { /*show: showProp = false, */ onShow = false } = this.props;
        //const { show: showState, autoDismiss } = this.state;

        if (onShow) {
            onShow();
        }

        // let dismissTO = null;
        // const show = showProp || showState;

        // if(show && (autoDismiss !== false)) {
        //     dismissTO = setTimeout(this.dismiss, (autoDismiss * 1000));
        // }

        //this.setState({ dismissTO });
    }

    onDismiss() {
        const { onDismiss = false } = this.props;

        if (onDismiss) {
            onDismiss();
        }
    }

    dismiss(e) {
        // let { dismissTO } = this.state;

        // if(dismissTO) {
        //     clearTimeout(dismissTO);
        //     dismissTO = null;
        // }

        this.setState({ /*dismissTO, */ show: false });

        this.onDismiss();
    }

    render() {
        const {
            show: showProp = false,
            children = "",
            type = "info",
            dismissable = false,
            icon = false,
            className = "",
        } = this.props;
        const { id, show: showState } = this.state;

        const customAttrs = { id };
        const show = showState || showProp;

        if (show) {
            this.onShow();
        }

        const classNames = ["ubx-commons", "notice", type, className];

        if (icon === true) {
            customAttrs["icon"] = "";
        }

        return show ? (
            <div className={classNames.join(" ")} {...customAttrs} onClick={(e) => this.onClick(e)}>
                {dismissable ? (
                    <a href="#dismiss" onClick={(e) => this.dismiss(e)}>
                        Close
                    </a>
                ) : (
                    ""
                )}
                <div className="notice-content">{children}</div>
            </div>
        ) : (
            ""
        );
    }
}
